import React from "react";
import ScrollLTR from "../../scrollLTR/ScrollLTR";
import classes from "./ContentPopup.module.css"

const ContentsPopup = ({ children, className, accessibilityDescription }) => {

    return (
        
        // <AccessibilityPopup accessibilityDescription={accessibilityDescription} close={() => console.log('close')}>
             <ScrollLTR height={"calc(100% - 101px)"} dropClass={classes.ScrollLTR}>
                <div className={`${classes.ContentsPopup} ${className}`} >
                    {children}

                </div>
             </ScrollLTR >
        // </AccessibilityPopup>
    )
}

export default ContentsPopup;